module.exports = __webpack_public_path__ + "img/eth.4108b8ee.png";